module.exports = __webpack_public_path__ + "img/platform@2x.3c0c5a9c.png";